export default __webpack_public_path__ + "static/media/archive.0459a6a4.svg";